<template>
	<app>
		<c-form ref="form">
			<c-form-item type="hidden" name="project_id"></c-form-item>
			<c-form-item type="select" label="中标企业" name="zbqy_id" options="COMPANY_LIST" required search></c-form-item>
			<c-form-item type="number" decimal="2" label="中标金额" name="zb_money" required input-word="元"></c-form-item>
			<c-form-item type="file" label="中标通知书" name="zb_path" required file-type="word,excel,pdf,zip,image"></c-form-item>
			<c-form-item label="需购买保函" name="bx_type_ids" required>
				<c-checkbox-group v-model="currentInsurance">
					<c-checkbox v-for="(item, i) in insuranceType" :key="i" :value="item.value">{{item.name}}</c-checkbox>
				</c-checkbox-group>
			</c-form-item>
			<c-form-item type="input" label="被保险人" name="bbxr_name" required></c-form-item>
			<c-form-item type="input" label="被保险人组织代码" name="bbxr_jgdm" required></c-form-item>
			<c-form-item type="datetime" label="签约截止日" name="qy_last_date" required></c-form-item>
			<c-form-item type="number" label="工期" name="sggq" input-word="天" required></c-form-item>
			<c-form-item type="textarea" label="备注说明" name="zb_remark"></c-form-item>
		</c-form>
		
		<div slot="button">
			<c-button size="m" @click="submitHandle">确认并提交</c-button>
		</div>
	</app>
</template>

<script>
	import {mapGetters} from 'vuex'
	
	export default {
		props: {
			id: String
		},
		
		data() {
			return {
				insuranceType: [],
				currentInsurance: []
			}
		},
		
		mounted() {
			this.$refs.form.set({
				project_id: this.id
			});
			this.request({
				url: '/bx_type/list',
				success: data => {
					this.insuranceType = Array.from(data, item => {
						return {
							name: item.type_name,
							value: item.type_id
						}
					});
					this.$nextTick(() => {
						this.currentInsurance = Array.from(data, item => item.type_id);
					});
				}
			});
			this.request({
				url: '/project/detail',
				data: {
					project_id: this.id
				},
				success: data => {
					this.$refs.form.set({
						bbxr_name: data.project_info.yzdw_name,
						bbxr_jgdm: data.project_info.yzdw_yyzzh
					});
				}
			});
		},
		
		methods: {
			submitHandle() {
				this.$refs.form.submit({
					url: '/project/set_zbqy',
					rule: {
						zbqy_id: '请选择中标企业',
						zb_money: '请填写中标金额',
						zb_path: '请上传中标通知书',
						bbxr_name: '请填写被保险人',
						bbxr_jgdm: '请填写被保险人组织代码',
						qy_last_date: '请选择签约截止日',
						sggq: '请填写工期'
					},
					dataFormatter: data => {
						data.bx_type_ids = this.currentInsurance;
						return data;
					},
					success: () => {
						this.$message({
							text: '提交成功'
						});
						this.navigateBack();
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
